interface OdometerProps {
  count: number;
  className?: string;
}

const Odometer = ({ count, className = "text-green-400" }: OdometerProps) => {
  const formattedCount = count.toString();

  const odometerNumber = (num: number, index: number, leftMargin: boolean) => {
    return (
      <div
        key={index}
        className={`odometer-animation ${className}`}
        style={{
          marginLeft: leftMargin ? "0.2em" : "0",
          transform: `translate(0px, ${num}em`,
        }}
      >
        {[...Array(10).keys()].reverse().map((n) => {
          return (
            <div
              key={"number" + n}
              className="text-right"
              style={{ height: "1em", minWidth: "0.3em" }}
            >
              {n}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <span className="odometer-number">
      <div
        className="flex overflow-y-hidden"
        style={{ height: "1em", lineHeight: "0.95em", alignItems: "flex-end" }}
        aria-label={count.toString()}
      >
        {[...formattedCount].map((a, i) => {
          return odometerNumber(
            Number(a),
            formattedCount.length - i,
            (formattedCount.length - i) % 3 === 0 && i > 0
          );
        })}
      </div>
    </span>
  );
};

export default Odometer;
